import React from 'react';

import { useField } from 'formik';
import { numToLetter } from '~/commons/helpers';
import FormField from '~/commons/components/FormField.jsx';
import Alert from '~/commons/components/Alert.jsx';

const FieldsOrdering = ({
  qtnIndex: i,
  question: q,
  answeredSeq,
  isCorrect,
  correctAns: cAns,
  disabled = false,
}) => {
  const [, { error }] = useField(`answers[${i}].answeredSeq`);

  return (
    <div>
      {/* duplicated error alert */}
      {typeof error === 'string' && (<Alert>
        請勿重複
      </Alert>)}
      {/* answer */}
      {q.choices.map(({c, ii},jj) => (
        <div key={jj} className="my-2">
          <div className="form-row align-items-center">
            <div className="col-auto">
              {(jj+1)}.
            </div>
            <div className="col">
              <FormField
                className="py-1 h-auto rounded"
                name={`answers.${i}.answeredSeq.${jj}`}
                as="select"
                disabled={disabled}
              >
                <option value="">請選擇答案</option>
                {q.choices.map(({c:o, ii:iii},jjj) => (
                  <option
                    key={iii}
                    value={iii.toString()}
                  >{numToLetter(jjj, true)}. {o}</option>
                ))}
              </FormField>
            </div>
          </div>
        </div>
      ))}
      {/* answered */}
      {answeredSeq
        && !answeredSeq.includes(undefined)
        && !answeredSeq.includes('')
        && (
          <div className={`
            mt-3 py-2 px-4 position-relative
            ${
              cAns !== undefined && !isCorrect
                ? 'bg-light' : 'bg-quinary'
            }
          `}>
            我的答案:
            &nbsp;
            {answeredSeq
              .map(a=>(q.choices.indexOf(q.choices.find(c=>c.ii==a))))
              .filter((a) => a !== undefined && a !== '')
              .map((a) => numToLetter(a, true))
              .join(' > ')
            }
            {/* correct/incorrect mark */}
            {cAns !== undefined && (
              <img
                className="pos-abs-br mr-3 mb-2"
                {...isCorrect ? {
                  src: '/assets/img/correct.svg',
                  style: { width: '42px', height: '36px' },
                } : {
                  src: '/assets/img/incorrect.svg',
                  style: { width: '34px', height: '40px' },
                }}
              />
            )}
          </div>
        )}
      {/* correct answer */}
      {(cAns !== undefined && !isCorrect) && (
        <div className="text-tertiary mt-3 py-2 px-4">
          正確答案:
          &nbsp;
          {cAns
            .map((a) => numToLetter(a, true))
            .join(' > ')
          }
        </div>
      )}
    </div>
  );
};

export default FieldsOrdering;
